// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"index_itemsContainer__3zle_"};